/* import __COLOCATED_TEMPLATE__ from './current-selected-owner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();